
/**
 * Converti une chaîne vide ou null en undefined
 */
export const toStringOrUndefined = ({ value }: { value: any }): string | undefined => {
  if (value === null || value === undefined || value === '') return undefined
  return String(value)
}

/**
 * Parse une chaîne JSON stringifiée ou retourne la valeur par défaut
 */
export const parseJsonOrDefault = (defaultValue: any) => ({ value }: { value: any }) => {
  if (!value) return defaultValue
  if (typeof value === 'object') return value
  try {
    return JSON.parse(value)
  } catch (error) {
    return defaultValue
  }
}
